import { useEffect, useState } from "react";
import { BrushSvg } from "../../icons/Icon";

const ColorBox = (p) => {

    const [color, setColor] = useState(p.value || '#ffffff');

    const onChange = (e) => {
        if (e.target.value) {
            setColor(e.target.value);
        } else {
            setColor('transparent');
        }
    };
    useEffect(() => {
        setColor(p.value || '#ffffff');
    }, [p.value]);

    return (
        <div className="ColorBox">
            <label>
                <span>color</span>
                <div className="ColorBox-input" >
                    <figure style={{ backgroundColor: color }}><BrushSvg /></figure>
                    <input type="text" name="color" value={color} onChange={onChange} placeholder="type color code" />
                </div>
            </label>
        </div>
    );
};

export default ColorBox;